export const LogoMark = ({ className = "h-10 w-auto", variant = "dark" }) => (
  <img
    src={`/images/logo/mark-${variant}.png`}
    alt="PILATES ON."
    className={`${className} select-none transition-opacity duration-500`}
    draggable="false"
    data-testid="logo-mark"
  />
);

export const LogoFull = ({ className = "h-32 w-auto", variant = "brand" }) => (
  <img
    src={`/images/logo/logo-${variant}.png`}
    alt="PILATES ON. WORLD OFF."
    className={`${className} select-none`}
    draggable="false"
    data-testid="logo-full"
  />
);
